import {
  IncapacitatedReport,
  IncapacitatedReportCriteria,
} from '@src/main/modules/reports/incapacitated/domain/incapacitated-report.interface';
import { IncapacitatedReportRepository } from '@src/main/modules/reports/incapacitated/domain/incapacitated-report.repository';
import { parseIncapacitatedReportCriteria } from '@src/main/modules/reports/incapacitated/infrastructure/incapacitated-report-criteria.mapper';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

const path = '/incapacitated_report';

export const createIncapacitatedReportHttpRepository = (
  tokenProvider: TokenProvider,
): IncapacitatedReportRepository => new IncapacitatedReportHttpRepository(tokenProvider);

class IncapacitatedReportHttpRepository implements IncapacitatedReportRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  async findByCriteria(
    criteria: IncapacitatedReportCriteria,
  ): Promise<PageResponse<IncapacitatedReport>> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');

    return await api.get<PageResponse<IncapacitatedReport>>(
      `${path}/all`,
      token,
      parseIncapacitatedReportCriteria(criteria),
    );
  }
}
